import {ReactStateSetter} from '../types.ts';

export default function assertNonNullStateSetter<T>(
    setter: ReactStateSetter<T | null>
): ReactStateSetter<NonNullable<T>> {
    return setter as ReactStateSetter<NonNullable<T>>;
}
